export const PROPERTY_TYPE_ALL = 'property_type_all';

export function isPropertyTypeAll(propertyType) {
    return propertyType === PROPERTY_TYPE_ALL;
}
